export default "__VITE_ASSET__aGf$DIcv__"